/**
 * Generate formData from received argument
 *
 * @param {{data: Record<string, any>; entity_id: string | number; entity_type: string; sort?: string }} { data, entity_id, entity_type, sort = '' }
 * @return {FormData}
 */
export const formDataGenerator = ({ data, entity_id, entity_type, sort = '' }) => {
  const formData = new FormData()
  formData.append('entity_id', entity_id)
  formData.append('entity_type', entity_type)
  formData.append('sort', sort)

  for (const key in data) {
    /* Array */
    if (typeof data[key] === 'object' && Array.isArray(data[key])) {
      for (const index in data[key]) {
        formData.append(`${key}[${index}]`, data[key][index])
      }
    }
    // Object but not file or blob
    else if (typeof data[key] === 'object' && !(data[key] instanceof File || data[key] instanceof Blob)) {
      formData.append(key, JSON.stringify(data[key]))
    }
    // Another types
    else formData.append(key, data[key])
  }

  return formData
}
